const PARAGRAPH_VIDEO = (uuid: string, language: string) => `
  paragraphsDataUUID(uuid: "${uuid}", language: "${language}") {
  ... on FeaturedVideos {
      id
      button {
        title
        url
      }
      heading
      icon
      type
      uuid
      bottomSeparator
      videos {
        nid
        allAffiliates
        author
        bodyListing
        categories {
          alias
          color
          name
          weight
        }
        featuredImage {
          alt
          animatedGif
          archived
          caption
          copyright
          crop_image_style_4_3
          ctaBlockLogo
          ctaIconBlockLandscape
          ctaIconBlockSquare
          description
          downloadable
          horizontalCardImage
          latestEpisodeImage
          newsFeaturedImage
          podcastEpisodeImage
          promotionBlockLandscape
          promotionBlockLandscapeMedium
          responsiveImage
          smallPromotionBlockLandscape
        }
        memberOnly
        pathAlias
        publishedOn
        sidebarBoxes
        statusCode
        statusMessages
        summaryListing
        title
      }
    }
  }
`;

export default PARAGRAPH_VIDEO;
